import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import ExternalLink from "../layout/externalLink"

import TagsList from "./TagsList"


export default ({ publication, position, onTagClick, activeTags, includeMeta }) => {
  const { volume, number, author, title, year, journal, doi, pages, meta } = publication
  
  const pdfs = []
  const supplements = []
  const newsLinks = []
  let editorHighlight = null
  let tags = null

  if (meta !== null) {
    const { remotePdf, localPdf, remoteSuppl, mediaCoverage } = meta
    editorHighlight = meta.editorHighlight

    tags = meta.tags

    if (remotePdf !== null) {
      pdfs.push(remotePdf)
    }

    if (localPdf !== null) {
      const { publicURL} = localPdf
      pdfs.push(publicURL)
    }
    remoteSuppl.forEach((remote) => (
      supplements.push(remote)
    ))

    if (mediaCoverage !== null) {
      mediaCoverage.forEach((link) => {
        newsLinks.push(link)
      })
    }
  }
  

  const hasFiles = pdfs.length > 0 || supplements.length > 0
  const hasNews = newsLinks.length > 0
  const hasTags = tags !== undefined && tags.length > 0
  
  let volNumber = null
  if (volume && number) {
    volNumber = `${volume}(${number})`
  } else if (volume) {
    volNumber = `${volume}`
  }

  return (
    <li className="publication media">
      <div className="media-left has-text-right">
        <p>
          {position}
          .
        </p>
      </div>
      <div className="media-content">
        <div className="content">
          <p>
            <span dangerouslySetInnerHTML={{ __html: author }} />
            {` `}
            (
            {year}
            ),
            {` `}
            <span dangerouslySetInnerHTML={{ __html: title }} />
            <em className="nowrap">
            ,{` `}{journal}
            </em>
            {volNumber && (
              <span>
                ,{` `}{volNumber}
              </span>
            )}
            {pages && (
              <span>
                ,{` `}{pages}
              </span>
            )}
            {doi && doi !== "" && ! doi.startsWith("none_") && (
              <span className="nowrap">
                ,{` `}doi:
                <ExternalLink path={`http://doi.org/${doi}`} title={doi}>
                  {doi}
                </ExternalLink>
              </span>
            )}
            .
            {editorHighlight && includeMeta && (
              <span>
                {` `}
                <a className="tag editor-highlight" href={editorHighlight} rel="noopener noreferrer" target="_blank">Editor Highlight</a>
              </span>
            )}
            {hasFiles && includeMeta && (
              <span>
                {` `}
                <span className="links">
                  {pdfs && pdfs.map((pdf) =>(
                    <ExternalLink key={pdf} title="PDF" path={pdf}>
                      <FontAwesomeIcon icon={["far", "file-pdf"]} title="PDF" />
                    </ExternalLink>
                  ))}
                  {supplements && supplements.map((supp) => (
                    <ExternalLink key={supp} title="Supplement" path={supp}>Supplement</ExternalLink>
                  ))}
                </span>
              </span>
            )}
          </p>
          {hasTags && includeMeta && (
            <TagsList tags={tags} onTagClick={onTagClick} activeTags={activeTags} />
          )}
          {hasNews && includeMeta && (
            <div className="news level">
              <div className="level-left">
                <p className="level-item"><strong>In the News:</strong></p>
                {newsLinks && newsLinks.length > 0 && (
                  <ul className="level-item is-unstyled">
                    {newsLinks.map((link) => (
                      <li key={link.id}><ExternalLink title={link.title} path={link.url}>{link.site}</ExternalLink></li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </li>
  )
}